
import { PureComponent, HTMLProps } from 'react';
import classNames from 'classnames';
import watermark from './watermark.png';

export class Watermark extends PureComponent<HTMLProps<HTMLElement>> {
    render() {
        return <img
            className={classNames(this.props.className, 'watermark')}
            style={{ width: '133px', opacity: 0.44 }}
            src={watermark}
            alt="By Instructure CustomDev"
        />
    }
}

